import React from 'react';
import { string, bool, object } from 'prop-types';


const InputLabel = ({ label, dropdownLabel, darkBg, requiredField, styles }) => {
  let Dropdown = null;
  if (dropdownLabel) { Dropdown = require('./Dropdown').default; }
  const labelClass = dropdownLabel ? styles.dropdownLabel : styles.inputLabel;

  return (
    label || dropdownLabel ?
      <div className={styles.labelWrapper}>
        { label && <label className={labelClass}>{label}{requiredField && '*'} </label> }
        { dropdownLabel && <Dropdown darkBg={darkBg} simplified {...dropdownLabel} customClasses={'withInput'} autoWidth /> }
      </div> :
    null
  );
};

InputLabel.propTypes = {
  darkBg: bool,
  dropdownLabel: object,
  label: string,
  requiredField: bool,
  styles: object,
};

InputLabel.displayName = 'InputLabel';

export default InputLabel;



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/InputLabel.js